import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ComptePowensDisponible,
  ModificationSelectionComptesPowens,
} from '../../../services/comptes.service';

@Component({
    selector: 'app-popup-selection-powens',
    imports: [CommonModule],
    templateUrl: './popup-selection-powens.component.html',
    styleUrl: './popup-selection-powens.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupSelectionPowensComponent implements OnChanges {
  @Input() visible = false;
  @Input() comptes: ComptePowensDisponible[] = [];
  @Input() comptePrincipalId: number | null = null;
  @Input() comptesCarteIds: number[] = [];
  @Input() chargement = false;
  @Input() erreur: string | null = null;

  @Output() confirmer = new EventEmitter<ModificationSelectionComptesPowens>();
  @Output() annuler = new EventEmitter<void>();
  @Output() gererDansPowens = new EventEmitter<void>();

  comptePrincipalSelectionne: number | null = null;
  comptesCarteSelectionnes: number[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.visible &&
      (changes['visible'] ||
        changes['comptePrincipalId'] ||
        changes['comptesCarteIds'])
    ) {
      this.comptePrincipalSelectionne = this.comptePrincipalId;
      this.comptesCarteSelectionnes = [...this.comptesCarteIds];
    }
  }

  get comptesAssociesDisponibles(): ComptePowensDisponible[] {
    return this.comptes.filter(
      (compte) => compte.id !== this.comptePrincipalSelectionne,
    );
  }

  selectionnerComptePrincipal(compteId: number): void {
    this.comptePrincipalSelectionne = compteId;
    this.comptesCarteSelectionnes = this.comptesCarteSelectionnes.filter(
      (id) => id !== compteId,
    );
  }

  estCompteAssocieSelectionne(compteId: number): boolean {
    return this.comptesCarteSelectionnes.includes(compteId);
  }

  basculerCompteAssocie(compteId: number, selectionne: boolean): void {
    if (selectionne) {
      this.comptesCarteSelectionnes = [
        ...new Set([...this.comptesCarteSelectionnes, compteId]),
      ];
      return;
    }
    this.comptesCarteSelectionnes = this.comptesCarteSelectionnes.filter(
      (id) => id !== compteId,
    );
  }

  valider(): void {
    if (this.comptePrincipalSelectionne === null || this.chargement) return;
    this.confirmer.emit({
      comptePrincipalId: this.comptePrincipalSelectionne,
      comptesCarteIds: this.comptesCarteSelectionnes,
    });
  }

  fermer(): void {
    if (!this.chargement) this.annuler.emit();
  }

  typeLisible(type: string | null): string {
    switch (type?.toLocaleLowerCase('fr-FR')) {
      case 'checking':
        return 'Compte courant';
      case 'savings':
        return 'Épargne';
      case 'card':
      case 'deferred_card':
        return 'Carte différée';
      case 'loan':
        return 'Crédit';
      default:
        return type || 'Type non renseigné';
    }
  }

  estProbablementUneCarte(compte: ComptePowensDisponible): boolean {
    const type = compte.type?.toLocaleLowerCase('fr-FR') ?? '';
    return (
      type.includes('card') ||
      compte.compteParentId !== null ||
      compte.nom.toLocaleLowerCase('fr-FR').includes('carte')
    );
  }

  formatterMontant(montant: number | null): string | null {
    if (montant === null) return null;
    return montant.toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  trackByCompteId(_index: number, compte: ComptePowensDisponible): number {
    return compte.id;
  }
}
